<template>
<router-view>
</router-view>
</template>

<script>

</script>

<style>
    body{
        padding: 0;
        margin:0;
    }
</style>




